module.exports = __webpack_public_path__ + "img/PL08382.2de82eec.png";